import { z } from 'zod';

import { EmailSchema } from '@vestigas/utils';

import {
  REPROCESSING_INVOICE_CHANNEL,
  REPROCESSING_INVOICE_STATUS,
} from '../useQueryReprocessingInvoices';

export const zodFileTypeSchema = z.enum([
  'application/json',
  'application/xml',
  'application/pdf',
]);

export const zodAdditionalFileSchema = z.object({
  fileId: z.uuid(),
  fileName: z.string(),
  fileType: zodFileTypeSchema,
});

export const zodInvoiceMailSchema = z.object({
  attachments: z.array(zodAdditionalFileSchema),
  azureId: z.uuid(),
  bccAddresses: z.array(EmailSchema),
  ccAddresses: z.array(EmailSchema),
  content: z.string(),
  firstReadDatetime: z.string(),
  receivedDatetime: z.string(),
  receiverAddresses: z.array(EmailSchema),
  senderAddress: EmailSchema,
  subject: z.string(),
});

export const zodReprocessingInvoiceResponseSchema = z.object({
  additionalFiles: z.array(zodAdditionalFileSchema),
  currentParsedInvoice: z.record(z.string(), z.unknown()).nullable(),
  invoiceMails: z.array(zodInvoiceMailSchema),
  invoicePdfId: z.uuid().nullable(),
  originalPdfId: z.uuid(),
  processInformation: z.object({
    buyerName: z.string().nullable(),
    channel: z.enum(REPROCESSING_INVOICE_CHANNEL),
    comment: z.string().nullable(),
    createdOn: z.iso.datetime(),
    currency: z.string().nullable(),
    dryRun: z.boolean(),
    emailReceivedDatetime: z.iso.datetime().nullable(),
    emailSender: EmailSchema.nullable(),
    emailSubject: z.string().nullable(),
    id: z.uuid(),
    invoiceDate: z.iso.date().nullable(),
    invoiceNumber: z.string().nullable(),
    needsAiParsing: z.boolean(),
    parserUsed: z.string().optional(),
    processFinishedOn: z.iso.datetime().nullable(),
    recipientMatchedCompanyId: z.uuid().optional(),
    recipientMatchedCompanyName: z.string().nullable(),
    sellerName: z.string().nullable(),
    status: z.enum(REPROCESSING_INVOICE_STATUS),
    statusDetails: z.record(z.string(), z.unknown()).optional(),
    totalAmount: z.number().optional(),
    watermarkType: z.string().optional(),
  }),
});

export const zodReprocessingInvoiceEndpointSchema = z.tuple([
  z.literal('invoice'),
  z.literal('process'),
  z.uuid(),
]);
